var map = {
	"./www/index.vue": [
		"cGsf",
		0
	],
	"./www/main.vue": [
		"GgP7",
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "8aLV";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/components/raceLive lazy ^\.\/.*\.vue$
// module id = 8aLV
// module chunks = 4